import React, { Component, useEffect } from 'react';

const Loaded = React.lazy(() => import('./Loaded'));

import LoadWhenReady from '../../global/lib/LoadWhenReady';
import fixedHeightContent from '../../global/lib/fixedHeightContent';
import routeLeaveHook from '../../global/lib/routeLeaveHook';

import Loading from '../../global/components/Loading';
import {
  loadLegalHoldReasons,
  searchLegalHoldReasons,
  sortLegalHoldReasons,
  updateLegalHoldReasonsActiveColumns,
  resetLegalHoldReasons,
} from '../../global/state_managers/LegalHoldReasonsStateManager';
import { resetFilter } from '../../global/state_managers/SearchFormStateManager';
import { resetUnsavedSearch } from '../../global/state_managers/UnsavedSearchStateManager';
import { breadcrumbsActions } from '../../global/state_managers/BreadcrumbsStateManager';
import { resetStreamQuery } from '../../global/state_managers/SearchResults/searchResultsStream';

import { flashConnect, PAGES } from '../../global/components/FlashMessages';

import './HoldReasons.scss';

// Inner component that dispatches actions on mount
function HoldReasonsInner(props: any) {
  // Mount effect - dispatch actions after render
  useEffect(() => {
    props.resetStreamQuery();
    props.setBreadcrumbForHoldReasonsPage();
    props.resetFilter();
    props.resetUnsavedSearch();
    props.loadLegalHoldReasons({ populateCounts: true });

    // NOTE: intentionally no unmount cleanup resetting legalHoldReasons. This
    // list page reloads reasons on every mount (above), so the reset was
    // redundant — and worse, its unmount (a passive effect) races the assets
    // page's mount load: on newer react-dom the cleanup runs AFTER the assets
    // page loads, clearing legalHoldReasons.isLoaded and wedging that page on
    // the loading spinner. Dropping the reset removes the race entirely.
  }, []);

  return (
    <LoadWhenReady readyStates={[props.legalHoldReasons.isLoaded]}>
      <div data-view="hold-reasons">
        <React.Suspense fallback={<Loading />}>
          <Loaded {...props} />
        </React.Suspense>
      </div>
    </LoadWhenReady>
  );
}

// Apply HOCs
import { connect } from 'react-redux';

const mapStateToProps = ({ legalHoldReasons }: any) => ({
  legalHoldReasons,
  searchString: legalHoldReasons.searchString,
  returnCount: legalHoldReasons.reasons.length,
});

const mapActionsToProps = {
  loadLegalHoldReasons,
  searchLegalHoldReasons,
  sortLegalHoldReasons,
  updateLegalHoldReasonsActiveColumns,
  resetLegalHoldReasons,
  resetFilter,
  resetUnsavedSearch,
  setBreadcrumbForHoldReasonsPage: breadcrumbsActions.holdReasonsPage,
  resetStreamQuery,
};

const HoldReasons = routeLeaveHook(
  flashConnect(PAGES.HOLD_REASONS, 'HoldReasons')(
    connect(
      mapStateToProps,
      mapActionsToProps,
    )(fixedHeightContent(HoldReasonsInner))
  )
);

export default HoldReasons;
